/**
 * Operator ruling row 131 (2026-10-07, lane CQ-132): "Keep Satori (like the branded agent), not assistant." — the AI agent's bubbles
 * and lines in the conversation story, the transcripts and the exports carry the agent's branded persona name, never the generic word
 * "Assistant".  No brand knob names the agent today (`Brand:AgentDescription` describes it; `Brand:DisplayName` is the customer's brand,
 * which still owns the console chrome), so the name lives HERE, once — every string reads it as `{{agent}}` (the console's i18n
 * default variable, `src/i18n/index.js`).  Human agents keep their own names (CQ-127).
 */
export const AGENT_NAME = 'Satori';   // operator ruling row 131
